import React from "react";
import "./PrivacyPolicyPage.css";

const PrivacyPolicyPage = () => (
  <div className="privacy-page-bg">
  <div className="privacy-root">
    <h1 className="privacy-title">Privacy Policy</h1>
    <p>
      At Vicon Products, we value your privacy and are committed to protecting your personal information. This Privacy Policy describes how we collect, use, and safeguard your data when you interact with our website and services.
    </p>

    <h2>Information We Collect</h2>
    <ul>
      <li>
        <strong>Personal Information:</strong> Such as your name, email address, phone number, and address when you fill out forms or contact us.
      </li>
      <li>
        <strong>Usage Data:</strong> Information about how you use our website, including IP address, browser type, and pages visited.
      </li>
    </ul>

    <h2>How We Use Your Information</h2>
    <ul>
      <li>To provide and improve our products and services.</li>
      <li>To respond to your inquiries and provide customer support.</li>
      <li>To process orders and send important updates.</li>
      <li>To enhance website security and user experience.</li>
      <li>To comply with legal obligations.</li>
    </ul>

    <h2>Information Sharing</h2>
    <p>
      We do not sell, trade, or rent your personal information to third parties. We may share your data with trusted partners who assist us in operating our website and conducting our business, provided they agree to keep your information confidential.
    </p>

    <h2>Cookies</h2>
    <p>
      Our website may use cookies to enhance your browsing experience. You can choose to disable cookies through your browser settings, but this may affect certain functionalities of the site.
    </p>

    <h2>Data Security</h2>
    <p>
      We implement a variety of security measures to maintain the safety of your personal information. However, no method of transmission over the Internet is 100% secure.
    </p>

    <h2>Links to Other Sites</h2>
    <p>
      Our website may contain links to external sites. We are not responsible for the privacy practices or content of those sites.
    </p>

    <h2>Changes to This Policy</h2>
    <p>
      We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.
    </p>

    <h2>Contact Us</h2>
    <p>
      If you have any questions about this Privacy Policy, please contact us at <a href="mailto:vicondealer@gmail.com">vicondealer@gmail.com</a>.
    </p>
  </div>
  </div>
);

export default PrivacyPolicyPage;